import React, { useState, Fragment } from "react"
import { FaChevronDown } from "react-icons/fa6"
import { useTranslation } from "react-i18next"

import TdFormLevelModal from "./TdFormLevelModal"
import classes from "./index.module.scss"
import clsx from "clsx"

const TdFormLevel = props => {
  const { form, tables, setForm } = props

  const [t, i18n] = useTranslation()

  const [openModal, setOpenModal] = useState(false)

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div className={classes["item"]}>
        <div className={classes["title"]}>
          {t("طبقه")}
        </div>
        <div
          onClick={() => setOpenModal(true)}
          className={classes["input-container"]}
        >
          <span className={classes["input-text"]}>
            {form.level}
          </span>
          <FaChevronDown
            size={14}
            className={clsx(
              classes["input-icon"],
              isLtr && classes["input-icon-ltr"]
            )}
          />
        </div>
      </div>
      <TdFormLevelModal
        form={form}
        setForm={setForm}
        tables={tables}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
    </Fragment>
  )
}

export default TdFormLevel